import React from 'react'
import EditP from '../components/EditP'
import Main from '../layouts/Main'

function EditProduct() {
    return (
        <Main>
            <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
                <div>
                    <p className="fw-semibold fs-20 mb-0">Edit Product</p>
                </div>
            </div>
            <EditP />
        </Main>
    )
}

export default EditProduct